import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import { token } from "functions/Helper";
import CreatePeakHourTrips from "views/PeakHourTrips/CreatePeakHourTrips";
import DeactivatedPeakHourTripsList from "views/PeakHourTrips/DeactivatedPeakHourTrips";
import deletePeakHourTrips from "views/PeakHourTrips/DeletePeakHourTrips";
import EditPeakHourTrips from "views/PeakHourTrips/EditPeakHourTrips";
import InDraftPeakHourTripsList from "views/PeakHourTrips/InDraftPeakHourTrips";
import PublishedPeakHourTripsList from "views/PeakHourTrips/PublishedPeakHourTrips";

const peakHourTrip = () => {
  let views = [];

  if (
    token["booking.peak_hour_trips.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/PeakHourTripsList/InDraft",
        name: "In Draft",
        mini: "ID",
        component: InDraftPeakHourTripsList,
        layout: "/admin"
      },
      {
        path: "/PeakHourTripsList/Published",
        name: "Published",
        mini: "PU",
        component: PublishedPeakHourTripsList,
        layout: "/admin"
      },
      {
        path: "/PeakHourTripsList/Deactivated",
        name: "Deactivated",
        mini: "DE",
        component: DeactivatedPeakHourTripsList,
        layout: "/admin"
      }
    ]);
  }

  if (views.length === 0) {
    return [];
  }
  return [
    {
      collapse: true,
      name: "Peak Hour Trips",
      icon: MonetizationOnIcon,
      state: "PeakHourCollapse",
      views: views
    }
  ];
};

const peakHourTripHidden = () => {
  let views = [];

  if (
    token["booking.peak_hour_trips.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/PeakHourTrips/Create",
        name: "Create Peak Hour Trips",
        component: CreatePeakHourTrips,
        layout: "/admin"
      },
      {
        path: "/PeakHourTrips/Edit",
        name: "Edit Peak Hour Trips",
        component: EditPeakHourTrips,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/PeakHourTrips/Delete",
        name: "Delete Peak Hour Trips",
        component: deletePeakHourTrips,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  return [
    {
      collapse: true,
      name: "Peak Hidden",
      state: "peakHidden",
      hideInSidebar: true,
      views: views
    }
  ];
};

export { peakHourTrip, peakHourTripHidden };
